export default __webpack_public_path__ + "static/media/longchamp30.0f992bf8.jpg";